import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals"
import { useStockShareRoleConfig } from "../../@hooks"
import { resetStockShare, stockShareIsEmpty } from "../../signals"


export default function useStockShareSearch() {
	const { showToast } = useAppToast()
    const { urlApi } = useStockShareRoleConfig()

    const stockShareData = useSignal([])

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			resetStockShare()
			postSubmit(urlApi, { ...commonFiltersValue.value }).then(res => {
				if (!res?.length) stockShareIsEmpty.value = true
				stockShareData.value = res
			}).catch(() => isSystemBusy.value = true
			).finally(() => {
				isLoadingCommonFilters.value = false
			})
		})
	}, [isLoadingCommonFilters.value])
	
	return {
		stockShareData: stockShareData.value,
		stockShareIsEmpty: stockShareIsEmpty.value
	}
}